(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FCYMarketDepthController', FCYMarketDepthController);

    FCYMarketDepthController.$inject = ['$scope', '$rootScope', '$state',  '$uibModalInstance', '$stateParams', 
    'GlobalValues', 'OrderStatusDetails', 'MessageBox', '$filter', 'DateUtils', 'DefaultMarket', 'LimitSettings',
    'TradesDownload', 'GenerateDealTicket','CustomerBankRelationshipReport', 'EntityPermissions', '$controller',
    'MarketWatch'];

    function FCYMarketDepthController($scope, $rootScope, $state, $uibModalInstance, $stateParams, 
        GlobalValues, OrderStatusDetails, MessageBox, $filter, DateUtils, DefaultMarket, LimitSettings,
        TradesDownload, GenerateDealTicket,CustomerBankRelationshipReport, EntityPermissions, $controller,
        MarketWatch) {
        var vm = this;
        
        vm.clear=clear;
        vm.hasPermission = EntityPermissions.hasPermission;

        vm.globalValues = GlobalValues;
        vm.noOfRecordsPerPageOP = 10;
        vm.pageOP = 1;
        vm.noOfRecordsPerPageTrade = 10;
        vm.pageTrade = 1;
        vm.noOfRecordsPerPageOT = 10;
        vm.pageOT = 1;
        vm.noOfRecordsPerPageLimit = 10;
        vm.pageLimit = 1;

 vm.prepareOrderDTOFromMarketWatch = function(side, orderType, offerPrice, settlementDate, sessionStatus, marketData) {        
        var orderPayload = {
            side: side,                         // 'BUY' or 'SELL'
            orderType: orderType,               // 'SPOT'
            offerPrice: offerPrice,
            settlementDate: settlementDate,
            sessionStatus: sessionStatus,
            marketData: marketData
        };
        clear();
         $rootScope.$emit('onMarketOrderPrepared', orderPayload);
        }


        vm.getMarkData = function (tokenSeqNo) {
            return $rootScope.marketSessionMap[tokenSeqNo];
        };

        vm.getTickerPrice = function (tokenSeqNo) {
            return $rootScope.tickerPriceFCY[tokenSeqNo];
        };

       vm.getInstrumentStatus = function (tokenSeqNo) {
    var data = vm.getMarkData(tokenSeqNo);
    if (!data) return null;

    if (data.sessionTimingsDTO.status === 'CLOSED') {
        return 'CLOSED';
    }

    if (data.settlementDateHoliday) {
        return 'HOLIDAY';
    }

    if (!data.instrumentApplicable) {
        return 'UNAVAILABLE';
    }

    return null;
};
  function clear () {
            $uibModalInstance.dismiss('cancel');
          
        }
        
        
    }   
})();
